import { CREDENTIALS } from '../config/constants';

/**
 * Récupère la session utilisateur depuis le localStorage
 */
export const getSession = () => {
    try {
        const session = localStorage.getItem('gt_session_v2');
        if (!session) return null;
        const decrypted = atob(session);
        return decrypted === atob(CREDENTIALS.username) ? decrypted : null;
    } catch {
        return null;
    }
};

/**
 * Sauvegarde la session utilisateur dans le localStorage
 */
export const saveSession = (username) => {
    try {
        localStorage.setItem('gt_session_v2', btoa(username));
    } catch (e) {
        console.error('Session save error');
    }
};

/**
 * Supprime la session utilisateur du localStorage
 */
export const clearSession = () => {
    try {
        localStorage.removeItem('gt_session_v2');
    } catch (e) {
        console.error('Session clear error');
    }
};

/**
 * Valide les credentials de connexion
 */
export const validateCredentials = (username, password) => {
    try {
        const usernameMatch = btoa(username) === CREDENTIALS.username;
        const passwordMatch = btoa(password + 'salt_gravel_2024') === CREDENTIALS.passwordHash;
        return usernameMatch && passwordMatch;
    } catch {
        return false;
    }
};